__turbopack_context__.v({
  "closeButton": "styles-module__3S7kHG__closeButton",
  "offerModalTitleRow": "styles-module__3S7kHG__offerModalTitleRow",
});
